import React from "react";

const ROLES = [
  { key: "VENDOR", label: "Vendor" },
  { key: "CUSTOMER", label: "Customer" },
  { key: "TRANSPORTER", label: "Transporter" },
  { key: "JOB_WORKER", label: "Job Worker" },
  { key: "SERVICE_PROVIDER", label: "Service Provider" },
];

export default function RolesTab({ form, setForm }) {
  const toggleRole = (role) => {
    const exists = form.roles.includes(role);

    setForm({
      ...form,
      roles: exists
        ? form.roles.filter((r) => r !== role)
        : [...form.roles, role],
    });
  };

  return (
    <div className="erp-section">
      <div className="erp-section-title">
        Partner Roles
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 12,
        }}
      >
        {ROLES.map((r) => (
          <label
            key={r.key}
            style={{
              display: "flex",
              gap: 8,
              alignItems: "center",
              padding: 10,
              border: "1px solid #e5e7eb",
              borderRadius: 6,
              cursor: "pointer",
              background: form.roles.includes(r.key)
                ? "#ecfeff"
                : "#fff",
            }}
          >
            <input
              type="checkbox"
              checked={form.roles.includes(r.key)}
              onChange={() => toggleRole(r.key)}
            />
            {r.label}
          </label>
        ))}
      </div>
    </div>
  );
}
